import React from 'react';
import PropTypes from 'prop-types';
import InvoiceLineBasicInfoSection from './invoiceLineEditorSections/InvoiceLineBasicInfoSection';
import InvoiceLineShipSection from './invoiceLineEditorSections/InvoiceLineShipSection';
import InvoiceLineOtherFieldsSection from './invoiceLineEditorSections/InvoiceLineOtherFieldsSection';

const InvoiceLineEditor = props => {
  const handleInputChange = (ev, value, errorMessage) => props.onFieldChange(ev, value, errorMessage);

  return (
    <React.Fragment>
      {
        !props.fetchingInvoiceLineData &&
          <React.Fragment>
            <InvoiceLineBasicInfoSection
              basicInfoData={ props.invoiceLineData }
              onFieldChange={ handleInputChange }
            />
            <hr />
            <InvoiceLineShipSection
              invoiceLineData={ props.invoiceLineData }
              onFieldChange={ handleInputChange }
            />
            <hr />
            <InvoiceLineOtherFieldsSection
              invoiceLineData={ props.invoiceLineData }
              onFieldChange={ handleInputChange }
            />
          </React.Fragment>
      }
    </React.Fragment>
  );
};

InvoiceLineEditor.propTypes = {
  invoiceLineData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  fetchingInvoiceLineData: PropTypes.bool.isRequired
};

export default InvoiceLineEditor;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/InvoiceLineEditor.js